// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Request from '../../../../api/Request';
import { observable } from 'mobx';
import SubmitButton from '../../../Util/SubmitButton/SubmitButton';

@inject('messageStore')
@observer class ChangePass extends Component<any, any> {

	@observable password: string = '';
	@observable passwordConfirm: string = '';

	@observable loading: boolean = false;

	constructor(props: any) {
		super(props);

		this.changePassword = this.changePassword.bind(this);
	}

	changePassword() {

		if (this.loading) {
			return;
		}

		if (this.password === '') {
			this.props.messageStore.setMessage('error', 'a password has to be set');
			return;
		}
		if (this.passwordConfirm === '') {
			this.props.messageStore.setMessage('error', 'please confirm the given password');
			return;
		}

		if (this.password !== this.passwordConfirm) {
			this.props.messageStore.setMessage('error', 'the password and the confirmation field have to be the same');
			return;
		}

		this.loading = true;

		Request.put('/me/change/password', {
			password: this.password,
			passwordConfirm: this.passwordConfirm
		}, {}).then((response) => {
			this.loading = false;

			if (!response.status) {
				this.props.messageStore.setMessage('success', 'succefully changed the password')
			}
		})
	}

	render() {
		return (
			<div className="profile-edit-change-password">
				<h2>change password.</h2>
				<form onSubmit={(e) => {e.preventDefault(); this.changePassword();}}>
					<label>
						new password:
						<input type="password" name="pasword" value={this.password} onChange={(e) => this.password = e.target.value} />
					</label>
					<label>
						confirm new password:
						<input type="password" name="paswordConfirm" value={this.passwordConfirm} onChange={(e) => this.passwordConfirm = e.target.value} />
					</label>
					<SubmitButton text="change" loading={this.loading} />
				</form>
			</div>
		)
	}
}

export default ChangePass;

